import { useNavigate } from 'react-router';

import { editProjectFestival } from '@/domain/project-festival/actions/edit-project-festival.action';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import {
  selectCurrentProjectFestival,
  selectIsEditingProjectFestival,
} from '@/domain/project-festival/project-festival.selectors';
import { PageTitle } from '@/ui/components/PageTitle';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { EditProjectFormButtons } from '@/ui/pages/app/components/edit-project/EditProjectFormButtons';
import { EditProjectPaper } from '@/ui/pages/app/components/edit-project/EditProjectPaper';
import { ProjectFestivalForm } from '@/ui/pages/app/project/festival/components/ProjectFestivalForm';

export function EditProjectFestival() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectFestival);
  const isEditingProject = useAppSelector(selectIsEditingProjectFestival);

  const handleEditProject = async (data: ProjectFestival) => {
    try {
      const params = { project: data };
      await dispatch(editProjectFestival(params)).unwrap();
      navigate(`/app/projects/festival/${project?.id}`);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBackButton = () => {
    navigate(`/app/projects/festival/${project?.id}`);
  };

  if (!project) {
    return null;
  }

  return (
    <>
      <PageTitle
        title={translate('ProjectsFestival.edit-event-page-title')}
        backButtonText={project?.name}
        onClickBack={handleBackButton}
      />
      <EditProjectPaper>
        <ProjectFestivalForm
          project={project}
          type="edit"
          onSubmit={handleEditProject}
          buttons={
            <EditProjectFormButtons isEditingProject={isEditingProject} />
          }
        />
      </EditProjectPaper>
    </>
  );
}
